module.exports = __webpack_public_path__ + "825392985eee1f98613e18a4e6f41eec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cats/icon-clinic@2x.png
// module id = 1741
// module chunks = 0